// extracted by mini-css-extract-plugin
module.exports = {"profileImage":"Avatar--profileImage--23OCT","image":"Avatar--image--2090h"};